import {
    createExoSafeAttachmentPolicy,
    updateExoSafeAttachmentPolicy,
} from 'projects/angular-clarity/src/app/stores/client/powershell/exo/safe-attachment-policy/actions';
import { SafeAttachmentPolicy } from 'projects/angular-clarity/src/app/stores/client/powershell/exo/safe-attachment-policy/model';

export function Remediate(_tenant: string, data: SafeAttachmentPolicy[], schema: any) {
    const props = schema?.contains?.properties;
    const policyData: Partial<SafeAttachmentPolicy> = {
        Identity: props?.Identity?.const,
        Name: props?.Identity?.const,
        // Can't change it if we have created it , so it will always be the same
        Priority: props?.Priority?.const,
        Enable: props?.Enable?.const,
        Action: props?.Action?.const,
        QuarantineTag: props?.QuarantineTag?.const,
        Redirect: props?.Redirect?.const,
        RedirectAddress: props?.RedirectAddress?.const ?? null,
        SentTo: props?.SentTo?.items?.enum ?? [],
        SentToMemberOf: props?.SentToMemberOf?.items?.enum ?? [],
        RecipientDomainIs: props?.RecipientDomainIs?.items?.enum ?? [],
        ExceptIfSentTo: props?.ExceptIfSentTo?.items?.enum ?? [],
        ExceptIfSentToMemberOf: props?.ExceptIfSentToMemberOf?.items?.enum ?? [],
        ExceptIfRecipientDomainIs: props?.ExceptIfRecipientDomainIs?.items?.enum ?? [],
    };

    const existingPolicy = data.find((res) => res.Identity === policyData.Identity);

    if (existingPolicy) {
        return updateExoSafeAttachmentPolicy({ _tenant, data: policyData });
    } else {
        return createExoSafeAttachmentPolicy({ _tenant, data: policyData });
    }
}
